import { formatNumber } from '@ab-core/functions/formatting/formatNumber';
import type { Availability } from '@ab-core/graphql/dist';
import { getTestIdProp } from '@ab-core/testing';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import type { AvailabilitiesProps } from '..';
import { getAvailabilityText } from '../../../functions';

type AggregatedMainChannelAvailabilityType = Pick<
    Availability,
    'aggregatedMainChannelQuantity' | 'deliveryFromFactory' | 'procuredProduct'
> &
    Pick<AvailabilitiesProps, 'quantityUnit'>;

export const AggregatedMainChannelAvailability: FC<AggregatedMainChannelAvailabilityType> = (props) => {
    const { aggregatedMainChannelQuantity, deliveryFromFactory, procuredProduct, quantityUnit } = props;

    return (
        <div className="flex-justify-content-space-between" {...getTestIdProp('product-card-availability')}>
            <Text color={aggregatedMainChannelQuantity !== 0 ? 'black' : 'info'}>
                {getAvailabilityText({
                    aggregatedMainChannelQuantity,
                    deliveryFromFactory,
                    procuredProduct
                })}
            </Text>
            <Text color="positiveGreen">
                {aggregatedMainChannelQuantity !== 0 &&
                    `${formatNumber(aggregatedMainChannelQuantity)} ${quantityUnit}`}
            </Text>
        </div>
    );
};
